<div *ngIf="selectedReservation" class="sidebar-reservation">
  <div fxLayout fxLayoutGap="12px" fxLayoutAlign="start center" style="margin-bottom: 18px">
    <img
      *ngIf="selectedReservation.guest_picture && selectedReservation.guest_picture != '#'"
      fxFlex="40px"
      class="guest-picture"
      [src]="selectedReservation.guest_picture"
      [alt]="selectedReservation.guest" />

    <div fxFlex fxLayout="column" fxLayoutAlign="center start">
      <div class="grape-darker strong" fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
        <span fxFlex>{{ selectedReservation.guest }}</span>
        <img
          *ngIf="
            selectedReservation.manual &&
            selectedReservation.channel !== 'manual' &&
            selectedReservation.channel !== 'other'
          "
          fxFlex="0 0 20px"
          style="width: 20px; height: 20px"
          [src]="'/assets/iconography/manual.svg'"
          [alt]="selectedReservation.channel"
          [matTooltip]="'Manual booking'" />

        <img
          *ngIf="selectedReservation.channel && selectedReservation.platform !== 'ical'"
          fxFlex="0 0 20px"
          style="width: 20px; height: 20px"
          [src]="'/assets/iconography/' + (selectedReservation.channel | lowercase) + '.svg'"
          [alt]="selectedReservation.channel" />
      </div>
    </div>

    <sbnb-close (click)="close.emit()"></sbnb-close>
  </div>

  <ng-container>
    <sbnb-reservation-card
      [activeReservation]="selectedReservation"
      (eventUpdated)="selectedReservation = $event"
      (reservationNeedsUpdating)="reservationNeedsUpdating.emit()"></sbnb-reservation-card>

    <ng-container *ngIf="!selectedReservation.isParentChildReservation && selectedReservation.thread_uuid">
      <a [routerLink]="['/inbox/thread/' + selectedReservation.thread_uuid]">
        <sbnb-button
          *ngIf="perms$.hasAccessTo(Features.PERM_INBOX) | async"
          label="Jump to conversation"
          type="secondary"
          size="mini"
          [fullWidth]="true"></sbnb-button>
      </a>
    </ng-container>

    <!-- We're just showing this new sidebar experience for GP Tasks for Direct premium for now -->
    @if (selectedReservation.payment_provider === 'adyen' && (shouldShowGuestPortalTasks$ | async)) {
      <div class="-mx-6 block mt-6 border-t border-smoke p-6 pb-0 space-y-4 *:block">
        <sbnb-guest-portal-tasks
          [reservation]="selectedReservation"
          [propertyId]="selectedReservation.listing.property_id"></sbnb-guest-portal-tasks>

        <!-- Security deposit -->
        <sbnb-security-deposit-sidebar
          *ngIf="selectedReservation.platform === Channel.Direct"
          [reservation]="selectedReservation"></sbnb-security-deposit-sidebar>

        <!-- Upsells -->
        <sbnb-upsells-status
          *ngIf="selectedReservation.supports.upsells"
          [reservation]="selectedReservation"></sbnb-upsells-status>
      </div>
    } @else {
      <div class="-mx-6 block mt-6 border-t border-smoke p-6 pb-0 space-y-4 *:block">
        <!-- Copy guest portal link-->
        <sbnb-guest-portal-sidebar-link [reservationUuid]="selectedReservation.uuid"></sbnb-guest-portal-sidebar-link>

        <!-- Security deposit -->
        <sbnb-security-deposit-sidebar
          *ngIf="selectedReservation.platform === Channel.Direct"
          [reservation]="selectedReservation"></sbnb-security-deposit-sidebar>

        <!-- Guest vetting -->
        <sbnb-guest-vetting-status *ngIf="selectedReservation.autohost"></sbnb-guest-vetting-status>

        <!-- Rental agreements-->
        <sbnb-rental-agreements-sidebar-list
          *ngIf="
            (perms$.hasAccessTo(Features.PERM_INBOX) | async) === true &&
            (perms$.hasAccessTo(Features.PERM_RESERVATION_FINANCIALS) | async) === true
          "
          [canAddAgreement]="(perms$.hasAccessTo(Features.PERM_MANAGE_RESERVATIONS) | async) === true"
          [reservationUuid]="selectedReservation.uuid"
          [reservation]="selectedReservation"
          [propertyId]="selectedReservation.listing.property_id"></sbnb-rental-agreements-sidebar-list>

        <!-- Upsells -->
        <sbnb-upsells-status
          *ngIf="selectedReservation.supports.upsells"
          [reservation]="selectedReservation"></sbnb-upsells-status>
      </div>
    }

    <ng-container *ngIf="!selectedReservation.isParentChildReservation">
      <div class="calendar-sidebar-section">
        <sbnb-thread-notes
          *ngIf="perms$.hasAccessTo(Features.PERM_INBOX) | async"
          [uuid]="selectedReservation.thread_uuid"
          [note]="selectedReservation.note"
          (noteSaved)="selectedReservation.note = $event"></sbnb-thread-notes>
      </div>

      <div *ngIf="perms$.hasAccessTo(Features.PERM_INBOX) | async" class="calendar-sidebar-section">
        <sbnb-activity-feed [threadUuid]="selectedReservation.thread_uuid"></sbnb-activity-feed>
      </div>
    </ng-container>

    <!-- This is a phantom parent/child reservation - we show different actions -->
    <div
      *ngIf="selectedReservation.isParentChildReservation"
      class="text__small"
      fxLayout="column"
      fxLayoutGap="4px"
      style="margin: 24px 0; line-height: 1.7">
      <div fxLayout fxLayoutGap="6px" fxLayoutAlign="start center">
        <img src="/assets/iconography/parent-child-properties.svg" />
        <strong class="night-darker">Parent-child</strong>
      </div>
      <span>This property's calendar has been blocked due to a booking on a related property.</span>
    </div>

    <div *ngIf="selectedReservation.isParentChildReservation" fxLayout="column" fxLayoutGap="6px">
      <sbnb-button *ngIf="showJumpToBooking" size="mini" [fullWidth]="true" (click)="jumpToMainBookingParentChild()">
        Jump to booking
      </sbnb-button>

      <a [routerLink]="['/inbox/thread/' + selectedReservation.thread_uuid]">
        <sbnb-button
          *ngIf="perms$.hasAccessTo(Features.PERM_INBOX) | async"
          label="Jump to conversation"
          type="secondary"
          size="mini"
          [fullWidth]="true"></sbnb-button>
      </a>
    </div>
  </ng-container>
</div>
